import axiosInstance from "shared/axios";
import { COLLECTION_API, LOAN_API, PAYMENT_API,USER_API_URLS } from "shared/constants";
import { queryparamBuilder } from "shared/utils";

export const loanListing = (selected, search, params) => {
  let uri = LOAN_API.listing;
  if (selected) {
    if(search == undefined){
      uri += `${selected}`
    }
    else{
    uri += `?${selected}=${search}&`;
    }
  } else if (Object.keys(params).length) {
    uri += "?";
  }
  uri += queryparamBuilder(params);
  return axiosInstance.get(`${uri}`);
};
export const searchLoanListing = (selected, search, params) => {
  let uri = LOAN_API.searchLoanListing;
  if (selected) {
    if(search == undefined){
      uri += `${selected}`
    }
    else{
    uri += `?${selected}=${search}&`;
    }
  } else if (Object.keys(params).length) {
    uri += "?";
  }
  uri += queryparamBuilder(params);
  return axiosInstance.get(`${uri}`);
};

export const loanExtendedDetails = (loanRef) => {
  let url = `${LOAN_API.listing}/${loanRef}/extended`;
  return axiosInstance.get(url);
};
// https://admin-gateway.test.kissht.com/api/v1/loans/mapping?loan_reference_number=LOS19115512599819OWN
export const loadRepaymentMapping = (repaymentRef) => {
  let url = `${LOAN_API.listing}/mapping?repayment_reference_number=${repaymentRef}`;
  return axiosInstance.get(url);
};
export const disallowDuesWaiverApi = (loanRef) => {
  let url = `${LOAN_API.listing}/${loanRef}/disallow-dues-waiver`;
  return axiosInstance.post(url, { _method: "patch" });
};

export const loadDuesMapping = (duesRef) => {
  let url = `${LOAN_API.listing}/mapping?dues_reference_number=${duesRef}`;
  return axiosInstance.get(url);
};
export const updateScheduleDate = (json,transaction_reference_number) => {
  let url = `${LOAN_API.listing}/${transaction_reference_number}/update-future-emi-date`;
  return axiosInstance.post(url,json);
};
// api/v1/dues/DUES715842616988CE8A
export const fetchDuesDetails = (duesRef) => {
  let url = `${LOAN_API.dues}/${duesRef}`;
  return axiosInstance.get(url);
};

// {{admin-gateway-url}}/api/v1/dues?loan_reference_number=LOS15191986993987NK1&dues_type=SNOOZE_FEES,MORATORIUM_INTEREST,MORATORIUM
export const fetchLoanDuesListing = (loanReferenceNo) => {
  let url = `${LOAN_API.dues}?loan_reference_number=${loanReferenceNo}`;
  return axiosInstance.get(url);
};

// {{admin-gateway-url}}/api/v1/payments/list?loan_reference_number=LOS1915416958863YWJQ
export const fetchLoanPaymentListing = (userReferenceNo) => {
  let url = `${PAYMENT_API.listing}?user_reference_number=${userReferenceNo}&payment_status=PAID,REFUNDED,PROCESSING,BOUNCE`;
  return axiosInstance.get(url);
};

///api/v1/loans/LOS1931573697639L8Z7/sync
export const syncLoan = (loanReferenceNo) => {
  let url = `${LOAN_API.listing}/${loanReferenceNo}/sync`;
  return axiosInstance.post(url, {});
};

export const getMoratoriumDetails = (loanRef) => {
  let url = `${LOAN_API.listing}/${loanRef}/moratorium-details`;
  return axiosInstance.get(url);
};

export const activateMoratorium = (loanRef, param) => {
  let url = `${LOAN_API.listing}/${loanRef}/moratorium/activate`;
  return axiosInstance.post(url, param);
};

export const deActivateMoratorium = (loanRef) => {
  let url = `${LOAN_API.listing}/${loanRef}/moratorium/deactivate`;
  return axiosInstance.post(url, {});
};

export const applyMoratorium = (loanRef) => {
  let url = `${LOAN_API.listing}/${loanRef}/moratorium`;
  return axiosInstance.post(url, {});
};

export const sendMoratoriumPaymentLink = (loanRef, param) => {
  let url = `${LOAN_API.listing}/${loanRef}/moratorium/send-payment-link`;
  return axiosInstance.post(url, param);
};

export const generatePaymentLink = (param) => {
  let url = `${PAYMENT_API.view}/generate-link`;
  return axiosInstance.post(url, param);
};

export const getDuesWaiverDetails = (userRef) => {
  let url = `${USER_API_URLS.users}/${userRef}/due-waiver-details`;
  return axiosInstance.get(url);
};

export const deactivateDuesWaiver = (loanRef) => {
  let url = `${LOAN_API.listing}/${loanRef}/due-waiver/deactivate`;
  return axiosInstance.post(url, {});
};

export const activateDuesWaiver = (loanRef, param) => {
  let url = `${LOAN_API.listing}/${loanRef}/due-waiver/activate`;
  return axiosInstance.post(url, param);
};

export const calculateForeclosureDetails = (loanRef, param) => {
  let url = `${LOAN_API.listing}/${loanRef}/calculate-foreclosure`;
  return axiosInstance.post(url, param);
};

export const sendPaymentLink = (loanRef, type, param) => {
  let url = `${LOAN_API.listing}/${loanRef}/${type}/send-payment-link`;
  return axiosInstance.post(url, param);
};

export const duesWaivedOffCall = (param) => {
  let url = `${LOAN_API.dues}/waive-off`;
  return axiosInstance.post(url, param);
};
// api/v1/dues/DUES51794153444584K1/waive-off/undo
export const undodueWaivedOff = (dueRef) => {
  let url = `${LOAN_API.dues}/${dueRef}/waive-off/undo`;
  return axiosInstance.post(url, {});
};
export const getSettlementDetails = (loanRef) => {
  let url = `${LOAN_API.listing}/${loanRef}/settlement-details`;
  return axiosInstance.get(url);
};

export const getRestructureDetails = (loanRef) => {
  let url = `${LOAN_API.listing}/${loanRef}/restructure-details`;
  return axiosInstance.get(url);
};
export const getEmiHolidayDetails = (loanRef) => {
  let url = `${LOAN_API.listing}/${loanRef}/emi-holiday-details`;
  return axiosInstance.get(url);
};

export const activateCampaign = (loanRef, type, param) => {
  let url = `${LOAN_API.listing}/${loanRef}/${type}/activate`;
  return axiosInstance.post(url, param);
};
export const deActivateCampaign = (loanRef, type, param) => {
  let url = `${LOAN_API.listing}/${loanRef}/${type}/deactivate`;
  return axiosInstance.post(url, param);
};

export const sendCampaignPaymentLink = (param) => {
  const { campaign, loan_reference_number } = param;
  let type = campaign.toLowerCase();
  let url = `${LOAN_API.listing}/${loan_reference_number}/${type}/send-payment-link`;
  return axiosInstance.post(url, param);
};

export const sendUserPaymentLink = (userRef, param) => {
  // users/2110453478117293/send-payment-link
  let url = `${LOAN_API.listing}/users/${userRef}/send-payment-link`;
  return axiosInstance.post(url, param);
};

export const cancelLoanApi = (loan_ref_no, params) => {
  let url = `${LOAN_API.listing}/${loan_ref_no}/cancel`;
  return axiosInstance.post(url, params);
};

export const generateNOC = (loan_ref_no, params) => {
  let url = `${LOAN_API.listing}/${loan_ref_no}/noc/generate`;
  return axiosInstance.post(url, params);
};
export const downloadSOA = (loan_ref_no) => {
  let url = `${LOAN_API.listing}/${loan_ref_no}/soa/generate`;
  return axiosInstance.get(url);
};
export const addUnifinedComment = (param) => {
  let url = `${COLLECTION_API.listing}/unified-comments`;
  return axiosInstance.post(url,param);
};

export const reverseSnoozePayment = (param) => {
  let url = `${LOAN_API.listing}/snooze-reverse`;
  return axiosInstance.post(url,param);
};


